module.exports = __webpack_public_path__ + "static/img/blue-pin.7df97da9.png";